(function () {
  'use strict';

  angular.module('app').service('CostsAndPricesService', CostsAndPricesService);

  CostsAndPricesService.$inject = [
    'TourCostService',
    'TourPriceService',
    'TransportationCostService',
    'TransportationPriceService',
    'HotelCostService',
    'HotelPriceService',
    'PackageCostService',
    'PackagePriceService',
  ];

  function CostsAndPricesService(
    TourCostService,
    TourPriceService,
    TransportationCostService,
    TransportationPriceService,
    HotelCostService,
    HotelPriceService,
    PackageCostService,
    PackagePriceService
  ) {
    var service = {
      searchProductCosts: searchProductCosts,
      searchProductPickupCosts: searchProductPickupCosts,
      searchProductPrices: searchProductPrices,
      searchProductPickupPrices: searchProductPickupPrices,
    };

    return service;

    ////////////////

    function searchProductCosts(productType, product, filterCriteria) {
      var costs;
      switch (productType) {
        case 'tour':
          costs = TourCostService.searchTourCosts(product, filterCriteria);
          break;
        case 'transportation':
          costs = TransportationCostService.searchTransportationCosts(product, filterCriteria);
          break;
        case 'hotel':
          costs = HotelCostService.searchHotelCosts(product, filterCriteria);
          break;
        case 'package':
          costs = PackageCostService.searchPackageCosts(product, filterCriteria);
          break;
      }

      return costs;
    }

    function searchProductPickupCosts(productType, product, filterCriteria) {
      var costs;
      switch (productType) {
        case 'tour':
          costs = TourCostService.searchTourPickupCosts(product, filterCriteria);
          break;
        case 'transportation':
          costs = TransportationCostService.searchTransportationPickupCosts(
            product,
            filterCriteria
          );
          break;
      }

      return costs;
    }

    function searchProductPrices(productType, product, filterCriteria) {
      var prices;
      switch (productType) {
        case 'tour':
          prices = TourPriceService.searchTourPrices(product, filterCriteria);
          break;
        case 'transportation':
          prices = TransportationPriceService.searchTransportationPrices(product, filterCriteria);
          break;
        case 'hotel':
          prices = HotelPriceService.searchHotelPrices(product, filterCriteria);
          break;
        case 'package':
          prices = PackagePriceService.searchPackagePrices(product, filterCriteria);
          break;
      }

      return prices;
    }

    function searchProductPickupPrices(productType, product, filterCriteria) {
      var prices;
      switch (productType) {
        case 'tour':
          prices = TourPriceService.searchTourPickupPrices(product, filterCriteria);
          break;
        case 'transportation':
          prices = TransportationPriceService.searchTransportationPickupPrices(
            product,
            filterCriteria
          );
          break;
      }

      return prices;
    }
  }
})();
